import React, {Suspense} from 'react';
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom';
import {observer} from 'mobx-react';
import store from './store';
import Login from './page/login';
import NotFound from './component/NotFound';
import Welcome from './component/Welcome';
import Layout from './component/Layout';

const App = () => {
  const token = store.token || '';
  const menu = store.menu || [];

  const loadRouter = () => {
    const router = [];
    if (Array.isArray(menu) && !!menu.length) {
      menu.forEach(item => {
        if (Array.isArray(item.children) && !!item.children.length) {
          router.push(<Route key={`/${item.key}`} path={item.key}>
            {
              item.children.map(childItem => {
                const Component = React.lazy(() => lazyRetry(() => import(`./page/${item.key}/${childItem.key === 'new' ? 'edit' : childItem.key}`)));
                return (
                  <Route key={`/${item.key}/${childItem.key}`}
                         path={`${childItem.key}${childItem.key === 'edit' ? '/:id' : ''}`} element={<Component/>}/>
                )
              })
            }
          </Route>)
        }
      })
    }
    return router
  };

  const lazyRetry = function(componentImport) {
    return new Promise((resolve, reject) => {
      componentImport().then((component) => {
        resolve(component);
    }).catch((error) => {
        // TO DO
        console.log('页面崩溃',error)
        window.location.replace(window.location.href);
        reject(error); // there was an error
    });
  });
};

  return (
    <BrowserRouter>
      <Suspense fallback={<div className="b-c-fff"/>}>
        <Routes>
          <Route path="/login" element={<Login/>}/>
          <Route path="/" element={token ? <Layout/> : <Navigate to="/login"/>}>
            <Route path="" element={<Welcome isLoadingWelcome={false}/>}/>
            {loadRouter(menu)}
            <Route path="/*" element={<NotFound/>}/>
          </Route>
          <Route path="*" element={<Welcome isLoadingWelcome={false}/>}/>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default observer(App);